export const pluralize = (prefix: string, value: number | undefined) => (value && value === 1 ? prefix : prefix + 's')
